<template>
  <div class="main">
    <div class="absolute left-0 right-0 top-5 ml-5 mr-14 flex items-center gap-3 justify-between">
      <router-link :to="{ name: 'Settings' }">
        <div class="w-11 h-11" @click="$parent.sfx.touch.play()">
          <img class="rounded-full w-full h-full object-cover" :src="photoPreview ? photoPreview : require('../assets/images/slide-example.png')" alt="" />
        </div>
      </router-link>
      <div class="bg-white rounded-2xl py-4 px-5 shadow-3xl w-full">
        <div class="flex justify-between items-center">
          <p class="text-xs font-bold">{{ $t('homepage_profile_name') }}, {{ name }}</p>
          <div class="flex gap-1">
            <div class="life-full" v-for="index in life" :key="`life-full${index}`">
              <img src="../assets/images/life-full.svg" alt="">
            </div>
            <div class="life-empty" v-for="index in 3 - life" :key="`life-empty${index}`">
              <img src="../assets/images/life-empty.svg" alt="">
            </div>
          </div>
        </div>
        <p class="text-base font-bold text-red-1" style="font-size: 14px; margin-top: 4px;" v-if="this.language == 'en'">{{ life !== 0 ? `You have ${life } lives remaining` : `Your lives refresh in ${resetLifeTimer}` }}</p>
        <p class="text-base font-bold text-red-1" style="font-size: 14px;text-align: center;margin-top: 4px;" v-else>{{ life !== 0 ? `เล่นได้อีก ${life } ครั้ง` : `เริ่มเล่นใหม่ในอีก ${resetLifeTimer}` }}</p>
      </div>
    </div>
    <div class="fixed left-0 right-0 top-1/10">
      <img src="../assets/images/get-ready-coffee.png" alt="" style="width: 75%;margin: 0 auto;" v-if="this.language == 'en'">
      <img src="../assets/images/get-ready-th.png" alt="" style="width: 75%;margin: 0 auto;" v-else>
    </div>
    <div class="absolute bottom-0 left-0 right-0" style="z-index:2">
      <div class="mb-4 w-80 mx-auto">
        <router-link :to="{ name: 'Receipt' }" class="rounded-2xl bg-green-3 py-2 flex items-center justify-center gap-2" v-if="!has_uploaded_receipt">
          <img src="../assets/images/camera.svg" alt="">
          <div @click="$parent.sfx.touch.play()">
            <p class="text-xs font-bold text-white">{{ $t("homepage_receipt_1") }}</p>
            <p class="text-xs font-bold text-white">{{ $t("homepage_receipt_2") }}</p>
          </div>
        </router-link>
        <div class="rounded-2xl bg-white-5 py-2 px-4 flex items-center justify-center gap-2 shadow-5xl" v-else>
          <img src="../assets/images/camera.svg" alt="">
          <div @click="$parent.sfx.touch.play()">
            <p class="text-xs text-white">{{ $t("homepage_done_receipt_1") }}</p>
            <p class="text-xs text-white">{{ $t("homepage_done_receipt_2") }}</p>
          </div>
        </div>
      </div>
      <div class="bg-purple-1 rounded-t-xxl">
        <div @click="$parent.sfx.touch.play()">
        <router-link to="/leaderboard" class="py-3 pl-7 pr-10 w-full text-center flex justify-between">
          <div class="flex items-center">
            <img class="w-10 h-10" src="../assets/images/star.svg" alt="">
            <p class="text-yellow-1 text-lg font-bold">{{ $t("homepage_leaderboard") }}</p>
          </div>
          <div class="flex items-center gap-2.5">
            <p class="text-white text-sm font-bold">{{ myPoint }} {{ $t("homepage_points") }}</p>
            <img src="../assets/images/arrow-right.svg" alt="">
          </div>
        </router-link>
        </div>
        <div class="bg-linear-5 rounded-t-xxl px-5 pb-5 pt-7 w-full">
          <div class="flex flex-col gap-5">
            <button @click.stop="play('multiPlayer')" class="btn bg-gray-7 py-4 block w-full rounded-xl flex items-center justify-center gap-3 font-bold text-base text-white" disabled><img src="../assets/images/party-icon.svg" alt="">{{ $t("homepage_create_room") }}</button>
            <button @click.stop="play('solo')" class="btn bg-gray-7 py-4 block w-full rounded-xl flex items-center justify-center gap-3 font-bold text-base text-white" disabled><img src="../assets/images/solo-icon.svg" alt="">{{ $t("homepage_play_solo") }}</button>
          </div>
        </div>
      </div>
    </div>
    <ModalPages
      v-if="isModalVisible = pop_up_homepage"
      @close="closeModal"
    />
    <ModalEmail
      v-show="showModalEmail"
      @updateProfile='updateProfile'
    />

  </div>
</template>

<script>
// import Button from '@/components/Button.vue'
import AudioComponent from '@/components/AudioComponent.vue'
import ModalPages from '@/components/ModalPages.vue'
import ModalEmail from '@/components/ModalEmail.vue'
import firebaseRepository from '../firebase/firebaseRepository'
import helper from '../helper'
import { auth } from '../firebase/firebaseInit'
import { mapActions, mapState } from 'vuex'
import { collection, doc, getDocs, getFirestore, setDoc } from "firebase/firestore"
import moment from 'moment'

import { Howl } from 'howler';

export default {
  metaInfo() {
    return {
      title: "Homepage"
    };
  },
  components: {
    // Button
    AudioComponent,
    ModalPages,
    ModalEmail
  },
  computed: {
    ...mapState([
      'email',
      'has_uploaded_receipt',
      'pop_up_homepage',
      'life',
      'myPoint',
      'name',
      'audio_object'
    ]),
    photoPreview () {
      return this.$store.state.photoPreview === null ? require('../assets/images/icon-user.png') : this.$store.state.photoPreview
    }
  },
  data () {
    return {
      isModalVisible: true,
      showModalEmail: false,
      intervalLifeRemaining: null,
      resetLifeTimer: '00:00:00',
      audio: null,
      language: ''
    }
  },
  mounted () {
    this.language = process.env.VUE_APP_I18N_LOCALE
    console.log(this.language)
  },
  methods: {
    ...mapActions([
      'createRoom',
      'playSolo',
      'getUserProfile',
      'signOut'
    ]),
    playSound(sound) {
      this.$parent.sfx.touch.play()
    },
    async countdownLifeRemaining() {
      let tomorrow = moment().add(1, 'day').startOf('day').valueOf(),
          diffTime = tomorrow - moment().valueOf(),
          duration = moment.duration(diffTime, 'milliseconds')

      this.intervalLifeRemaining = setInterval(() => {
        duration = moment.duration(duration - 1000, 'milliseconds')
        let hour = duration.hours() < 10 ? `0${duration.hours()}` : duration.hours(),
            minute = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes(),
            second = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds()

        this.resetLifeTimer = `${hour} : ${minute} : ${second}`
      }, 1000)

      if (this.life !== 0) clearInterval(this.intervalLifeRemaining)
    },
    async play(type) {
      this.$parent.sfx.touch.play()
        return alert('sorry you cant play this right now')
      if (this.life <= 0) {
        return alert('Sorry, you can’t create a room because you don’t have any lives remaining. Try again tomorrow after your coffee break')
      }

      const roomId = helper.generateUUID()
      

      switch (type) {
        case 'multiPlayer':
          await this.$store.dispatch('createRoom', { room_id: roomId, type: type })
          this.$router.push({ name: 'Room', params: { id: roomId } })
          break;
      
        default:
          await this.$store.dispatch('playSolo', { room_id: roomId, type: type })
          this.$router.push({ name: 'games_play', params: { id: roomId } })
          break;
      }
    },
    async closeModal () {
      this.$store.commit('SET_MODAL_VISIBILITY', false)
      await firebaseRepository.updateDocument(`users/${auth.currentUser.uid}`, { pop_up_homepage: false })
    },
    updateProfile(email) {
      if (email == '') return alert('Please submit your email')
      this.$store.dispatch("updateUserProfile", { email: email })
      this.showModalEmail = false
    }
  },
  async created () {
    localStorage.setItem("currentTime", 0);

    await this.getUserProfile(auth.currentUser.uid)
    if (this.email === null) this.showModalEmail = true
    this.countdownLifeRemaining()
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.intervalLifeRemaining)
    next()
	}
}
</script>
